<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="employee_head_office"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="headOfficeForm"
          :redirect-detail="false"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Head Office Karyawan"
          addButton="Tambah Head Office"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center" v-if="!isEdit">Tambah Head Office Baru</h3>
            <h3 class="text-center" v-else-if="isEdit">Ubah Head Office</h3>
          </div>

          <b-form id="headOfficeForm" validated novalidate>
            <div v-if="!loadingSubmitModal">
              <b-row>
                <b-col sm="4">
                  <b-form-group label-for="name" label="Nama Divisi">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="$v.headOfficeForm.name.$model"
                      :state="!$v.headOfficeForm.name.$invalid"
                      required
                      placeholder="Nama Divisi"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >Nama head office harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group label-for="latitude" label="Latitude">
                    <b-form-input
                      id="latitude"
                      type="text"
                      v-model="$v.headOfficeForm.lat.$model"
                      :state="!$v.headOfficeForm.lat.$invalid"
                      required
                      placeholder="Latitude Office"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >Latitude head office harus di
                      isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group label-for="longitude" label="Longitude">
                    <b-form-input
                      id="longitude"
                      type="text"
                      v-model="$v.headOfficeForm.lng.$model"
                      :state="!$v.headOfficeForm.lng.$invalid"
                      required
                      placeholder="Longitude Office"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >Longitude head office harus di
                      isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group label-for="description" label="Deskripsi">
                    <b-form-textarea
                      id="description"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.headOfficeForm.description.$model"
                      :state="!$v.headOfficeForm.description.$invalid"
                    ></b-form-textarea>
                    <b-form-invalid-feedback
                      >Deskripsi harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <loading></loading>
            </div>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <div v-if="!loadingSubmitModal">
              <b-button
                type="button"
                size="sm"
                variant="danger"
                @click="cancelAdd"
              >
                <i class="fa fa-undo"></i> Back </b-button
              >&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="saveProcess"
                :disabled="$v.headOfficeForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import masterInterfaces from "@/templates/_master_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "employee_head_office",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      employee_head_office: [],
      loading: true,
      loadingSubmitModal: false,
      fields: [
        {
          key: "name",
          label: "Nama Head Office",
          class: "width-250",
          sortable: true,
        },
        {
          key: "lat",
          label: "Latitude Head Office",
          class: "width-250",
          sortable: true,
        },
        {
          key: "lng",
          label: "Longitude Head Office",
          class: "width-250",
          sortable: true,
        },
        { key: "description", label: "Deskripsi" },
        { key: "action", class: "width-50 text-center" },
      ],
      headOfficeForm: masterInterfaces.head_office,
      isEdit: false,
    };
  },
  validations: {
    headOfficeForm: {
      name: { required },
      lat: { required },
      lng: { required },
      description: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.getEmployeeHeadOffice();
    },
    getEmployeeHeadOffice: function () {
      this.axios
        .get("web/master/employee/head_office/all/")
        .then((response) => {
          this.employee_head_office = response.data.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function (e) {
      this.isEdit = true;
      this.resetForm();
      this.headOfficeForm = e;
    },
    resetForm: function () {
      for (var a in masterInterfaces.head_office) {
        masterInterfaces.head_office[a] = null;
      }
      this.headOfficeForm = masterInterfaces.head_office;
    },
    cancelAdd: function () {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
    },
    saveProcess: function (evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah head office ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .put("web/master/employee/head_office/edit/", this.headOfficeForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Head Office Berhasil",
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan head office ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .post("web/master/employee/head_office/add/", this.headOfficeForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Head Office Berhasil",
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah Head Office Gagal",
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Master Head Office Karyawan",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

  